import { Component, Output, EventEmitter, ElementRef } from '@angular/core';
import { NavParams, ViewController, Events } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoBibHoldingListPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-bib-holding-list-popover',
  templateUrl: 'co-bib-holding-list-popover.html'
})
export class CoBibHoldingListPopoverComponent {

  text: string;
  locationList: Array<any>;
  @Output() placeHoldOpen: EventEmitter<any> = new EventEmitter<any>();
  constructor(private navParams : NavParams, public viewCtrl: ViewController, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider, private el:ElementRef, private state : AppState) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
	this.locationList = this.navParams.data.locations;
    this.locationList.sort(function(a, b) {
      return a.location.name.localeCompare(b.location.name, undefined, {numeric: true, sensitivity: 'base'});
    });
    if (this.state.pickupLocation) {
      let current = this.locationList.filter((l,i) => {
          return l.location.code.toLowerCase() == this.state.pickupLocation.toLowerCase();
      });
      let rest = this.locationList.filter((l,i) => {
        return l.location.code.toLowerCase() !== this.state.pickupLocation.toLowerCase();
      });
      this.locationList = current.concat(rest);
    }
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick(this.el.nativeElement);
  }

  close(){
    this.viewCtrl.dismiss().catch(err=>{});
  }

  placeHold(){
    this.viewCtrl.dismiss({placeHold: true});
  }
}



// WEBPACK FOOTER //
// ./src/components/co-bib-holding-list-popover/co-bib-holding-list-popover.ts